export const INDS_CUSTOMER = 18;
export const INDS_TEAM_SUPPORT = 19;
export const INDS_ADMIN = 20;
export const INDS_OP_ADMIN = 21;
export const INDS_BIS_ADMIN = 22;
export const INDS_ACCOUNT_REP = 23;
